export const commonStringMessage = {
  UploadDocTypeValidation: "Please upload a PDF file.",
  UploadDocSizeValidation:
    "File size exceeds 30MB. Please upload a smaller file.",
    investorValidation: "Please select an investor.",
    AmountValidation: "Please add amount.",
    ReferralFeeValidation: "Please add Referral fee and it should be greater than 0.",
    PurchaseTypeValidation: "Please select a purchase type.",
    BuyerBeenInsideValidation: "Please answer this question (Has the Buyer been Inside the property?).",
    BuysInNameValidation: "Please select a value for Buys In Name (No entity).",
    LenderValidation: "Please add Lender.",
    PofValidation: "Please upload a Proof of Funds (POF) PDF.",
    RpaValidation: "Please upload a Signed RPA PDF.",
    BuyerVestingValidation: "Please add Buyer Vesting.",
};
